import jwtDecode from 'jwt-decode';
import Klickart from './klickart';
import TokenStrategyFactory from '../../auth/tokenStrategies/tokenStrategyFactory';
import { casEnabled, isColaborator } from '../../auth/authService';

const casPath = 'v1/api/tokens';
const jwtPath = 'users/token';

export default class TokenRequest extends Klickart {
  constructor(config = {}) {
    super(config);
    this.updatePathAndHeaders();
  }

  updatePathAndHeaders() {
    this.path = casEnabled() ? casPath : jwtPath;
    this.headers = TokenRequest.getHeaders();
  }

  static getHeaders() {
    if (casEnabled()) {
      const tokenName = isColaborator() ? 'colaborator' : 'cas';

      return {
        Authorization: `Bearer ${TokenStrategyFactory.getTokenStrategy(tokenName).getToken()}`,
        Accept: 'application/json',
      };
    }
    return {};
  }

  static getBody() {
    const REQUEST_BODY = { application: 'klickart-analytics', token_kind: 'jwt' };
    return casEnabled() ? null : REQUEST_BODY;
  }

  async token() {
    const body = TokenRequest.getBody();
    const config = { headers: this.headers };

    const response = await this.post('', body, config);
    TokenStrategyFactory.getTokenStrategy('jwt').setToken(response.data.token);

    return response.data.token;
  }

  decodeToken(token) {
    return jwtDecode(token);
  }
}



// WEBPACK FOOTER //
// ./src/services/request/tokenRequest.js